var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71563 19.7793C2.2132 19.7793 1.78878 19.4065 1.72398 18.9083C1.15344 14.5219 0.582909 10.1356 0.0123733 5.7492C-0.122527 4.71248 0.874773 4.00541 1.58417 4.63477C3.47937 6.31599 5.37447 7.99708 7.26967 9.6783C7.89367 10.2318 8.78267 10.0517 9.21527 9.28407L13.9486 0.886287C14.4488 -0.00115809 15.5512 -0.00115809 16.0514 0.886287L20.7847 9.28407C21.2173 10.0517 22.1063 10.2317 22.7303 9.6783C24.6255 7.99708 26.5206 6.31599 28.4158 4.63477C29.1252 4.00541 30.1225 4.71248 29.9877 5.7492C29.4171 10.1356 28.8466 14.5219 28.2761 18.9083C28.2113 19.4065 27.7868 19.7793 27.2844 19.7793H2.71563Z",
    fill: "url(#paint0_linear_9096_10055)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9096_10055",
    x1: 15,
    y1: 0.580079,
    x2: 15,
    y2: 20.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386371,
    stopColor: "#FFC531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.85e846caff4d36d5e36b0b5c7e5135f2.svg";
export { ForwardRef as ReactComponent };